import React, { useEffect, useState } from 'react'
import { Modal, ModalHeader, ModalBody, Button, ModalFooter, Row as RawRow, Col } from 'reactstrap'
import { setUserInfoForRxCreate } from '../../../actions'
import { connect, useDispatch } from 'react-redux'
import { createAHCCartForReimbursement, findUser, listAHCPackagesForUser, listPatientsByOps } from '../../../services/api/rx-transcription'
import { toast } from 'react-toastify';
import Select from 'react-select';

const Row = ({children, ...props}) => <RawRow {...props} style={{ margin: 0, ...(props.style || {}) }}>
    {children}
</RawRow>


const CreateCartForAHCReimbursement = ({
    isOpen,
    header,
    onClose = () => {},
    className = 'bg-info',
    userInfo
}) => {
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);
    const [userPhoneNumber, setUserPhoneNumber] = useState('');
    const [ahcPackages, setAhcPackages] = useState([]);
    const [selectedAhcPackage, setSelectedAhcPackage] = useState();
    const [userDependentPatients, setUserDependentPatients] = useState([]);
    const [selectedDependentPatient, setSelectedDependentPatient] = useState(null);

    const searchUser = () => {
        setIsLoading(true);
        findUser(userPhoneNumber)
            .then((response) => {
                dispatch(setUserInfoForRxCreate(response.body));
            })
            .catch((err) => {
                toast.error('User not found!');
            }).finally(()=>{
                setIsLoading(false);
            })
    };

    const handleSubmit = () => {
        setIsLoading(true);
        if(!userInfo.userId){
            toast.error('Select a valid user');
            setIsLoading(false);
            return;
        }
        if(!selectedAhcPackage){
            toast.error('Select at least one AHC package');
            setIsLoading(false);
            return;
        }

        if(!selectedDependentPatient.value){
            toast.error('Select a dependent patient');
            setIsLoading(false);
            return;
        }

        createAHCCartForReimbursement(userInfo.userId, selectedAhcPackage.value, selectedDependentPatient.value)
        .then(response => {
            toast.success('Cart created successfully!');
            clearAll();
            onClose();
        })
        .catch(err => {
            console.error(err);
            toast.error('Error creating cart for AHC reimbursement');
        }).finally(()=>{
            setIsLoading(false);
        })
    }

    const clearAll = () => {
        setUserPhoneNumber('');
        dispatch(setUserInfoForRxCreate({}));
        setAhcPackages([]);
        setSelectedAhcPackage(null);
        setUserDependentPatients([]);
        setSelectedDependentPatient(null);
    }

    useEffect(() => {
        if(userInfo && userInfo.userId){
            listAHCPackagesForUser(userInfo.userId)
                .then((response) => {
                    setAhcPackages(response.body.data);
                })
                .catch((err) => {
                    toast.error('Error fetching AHC packages!');
                });

            listPatientsByOps(userInfo.userId)
                .then((response) => {
                    setUserDependentPatients(response.body.result);
                })
                .catch((err) => {
                    toast.error('Error fetching dependent patients!');
                });
        }
    }, [userInfo]);


    return isOpen ? (<Modal isOpen={isOpen} toggle={onClose}>
        <ModalHeader className={className} toggle={onClose}>
            {header}
        </ModalHeader>
        <ModalBody>
            <Row style={{ marginBottom: '20px' }}>
                <Col md={12} lg={12} xl={12}>
                    <Row>
                        <Row style={{ color: '#555' }}>Enter user's phone number:</Row>
                        <Col style={{ paddingLeft: 0 }} md={8} lg={8} xl={8}>
                            <input
                                type="telephone"
                                placeholder={'Phone Number'}
                                value={userPhoneNumber}
                                onChange={(e) => setUserPhoneNumber(e.target.value)}
                                style={{ width: '100%' }}
                            />
                        </Col>
                        <Col md={4} lg={4} xl={4}>
                            <Button color="primary" size='sm' onClick={searchUser} disabled={isLoading}>
                                {isLoading ? 'Loading...' : 'Search User'}
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            {
                userInfo ? (<><Row style={{ marginBottom: '5px' }}>
                    <Col>
                        Name: <span className="font-weight-bold">{userInfo.userName ? userInfo.userName : 'N/A'}</span>
                    </Col>
                </Row><Row style={{ marginBottom: '5px' }}>
                        <Col>Sponsor Name: {userInfo.sponsorName ? userInfo.sponsorName : 'N/A'}</Col>
                    </Row><Row style={{ marginBottom: '5px' }}>
                        <Col>Gender: {userInfo.userGender ? userInfo.userGender : 'N/A'}</Col>
                    </Row><Row style={{ marginBottom: '5px' }}>
                        <Col>Email: {userInfo.userEmail ? userInfo.userEmail : 'N/A'}</Col>
                    </Row></>) : null
            }
            <Row style={{ marginTop: '20px' }}>
                <Col>
                    <Row style={{ color: '#555' }}>Select Dependent Patient:</Row>
                    <Row>
                        <Select
                        isMulti={false}
                        options = {userDependentPatients.map(item => ({
                            value: item.patientId,
                            label: `${item.name} - ${item.gender}`
                        }))}
                        onChange={(selectedOption) => {
                            setSelectedDependentPatient(selectedOption);
                        }}
                        value={selectedDependentPatient}
                        isDisabled={userDependentPatients.length === 0}
                        placeholder="Select Dependent Patient"
                        styles={{ container: (base) => ({
                            ...base, 
                            width: '100%',
                            marginTop: '5px',
                            borderRadius: '5px',
                            border: '1px solid #ccc',
                            boxShadow: 'none',
                         }), control: (base) => ({
                            ...base,
                            border: 'none'
                         }) }}
                        />
                    </Row>
                </Col>
            </Row>
            <Row style={{ marginTop: '20px' }}>
                <Col>
                    <Row style={{ color: '#555' }}>Select Package:</Row>
                    <Row>
                        <Select
                            isMulti={false}
                            options={ahcPackages.map(item => ({
                                value: item.id,
                                label: `${item.packageName} - ${item.id}`
                            }))}
                            onChange={(selectedOption) => {
                                setSelectedAhcPackage(selectedOption);
                            }}
                            
                            value={selectedAhcPackage}
                            isDisabled={ahcPackages.length === 0}
                            placeholder="Select AHC Packages"
                            styles={{ container: (base) => ({
                                ...base, 
                                width: '100%',
                                marginTop: '5px',
                                borderRadius: '5px',
                                border: '1px solid #ccc',
                                boxShadow: 'none',
                             }), control: (base) => ({
                                ...base,
                                border: 'none'
                             }) }}
                        />
                    </Row>
                </Col>
            </Row>
        </ModalBody>
        <ModalFooter>
            <Button color="primary" onClick={handleSubmit} disabled={isLoading}>
                {isLoading ? 'Loading...' : 'Submit'}
            </Button>
            {!isLoading && (
                <Button color="secondary" onClick={()=>{
                    clearAll();
                    onClose();
                }} disabled={isLoading}>
                    Cancel
                </Button>
            )}
        </ModalFooter>
    </Modal>) : null;
}

const mapStateToProps = (state) => {
    return {
        userInfo: state.createLabRxDetails.userInfo
    }
}

export default connect(
    mapStateToProps,
)(CreateCartForAHCReimbursement);